import styled from '@emotion/styled';

export const MultiToggleWrapper = styled.div`
  border-radius: 4px;
  overflow: hidden;

  & > div:not(:last-child) {
    border-bottom: 1px solid var(--colorBlueGray900);
  }
`;
